import './App.css';
import { BrowserRouter, Routes, Route, Router } from "react-router-dom";

import FloatingWhatsapp from './components/Floartingwhatsapp';
import Footer from './components/Footer';
import Hero from './components/Hero';
import Nav from './components/Nav';

import Contact from './components/Contact';
import Service from './components/Service';
function App() {
  return (
    <>
<BrowserRouter>

    <header><Nav/></header>
    <FloatingWhatsapp/>

<Routes>
<Route path='/' element={<>
<main>
      <Hero/>


</main>

</>


}/>
              <Route path='/contact'element={<Contact/>}/>
<Route path='/service' element={<Service/>}/>
</Routes>
<footer>
      <Footer/>

</footer>

</BrowserRouter>





    </>
  );
}

export default App;
